export default function reducer(state = {
  motoristas: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_MOTORISTAS": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}